import { emitSocketV2ResearchAssistantEvent } from '@verantos-dev/app-state-base';

/**
 * Emit sync_concept_group_selections socket event.
 * This is a socket event specifically for syncing concept group selections.
 *
 * @param props - Event props containing cohortId, containerName (or markAll), and optional selections
 */
export const emitSyncConceptGroupSelections = (props: {
  cohortId: string;
  containerName?: string;
  markAll?: boolean;
  selections?: Array<{
    containerName?: string;
    containerType?: string;
    table?: string;
    filterType?: string;
    attribute?: string;
    span?: string;
    reported?: boolean;
    selectedConceptGroups?: unknown[];
    status?: string;
    confidence?: number;
    filterKey?: string;
    // Backend matches by anchorId first when upserting; for AV concept_ref edits this
    // is the cohort definition's concept_ref.id, which extract_filters_step also uses
    // as the anchor on the next chat turn (OR-5840).
    anchorId?: string;
  }>;
  newFilters?: Array<{
    containerName: string;
    containerType: string;
    filterType: string;
    attribute: string;
    selectedConceptGroups: Array<{ id: string; name: string }>;
  }>;
  // For container deletion cleanup - backend will delete all selections for this container
  deletedContainerName?: string;
}): void => {
  emitSocketV2ResearchAssistantEvent('sync_concept_group_selections', {
    data: {
      cohortId: props.cohortId,
      containerName: props.containerName,
      markAll: props.markAll,
      selections: props.selections,
      newFilters: props.newFilters,
      deletedContainerName: props.deletedContainerName,
    },
  });
};

/**
 * Emit create_concept_group_from_selection socket event.
 * Triggers the backend to create a concept group for a specific selection.
 *
 * @param props - Event props containing filter_key and span
 */
export const emitCreateConceptGroupFromSelection = (props: {
  anchor_id?: string;
  filter_key: string;
  span: string;
}): void => {
  emitSocketV2ResearchAssistantEvent('create_concept_group_from_selection', props);
};
